import type { GimbalUsageContext, GimbalUsageInput } from '../../../shared/camera-gimbal-usage';
import { compileExportFilm } from './export-film';
import { cinematicTimeline } from './cinematic-timeline';
import type { Ride } from './ride';

/** Entitlements inspect the same selected film and inherited IN settings as rendering. */
export function gimbalExportContext(trace: Ride, output: GimbalUsageInput & { durationSeconds: number }): GimbalUsageContext {
  const film = compileExportFilm(trace, output.durationSeconds, output.exportRange, output.cinematicSequence);
  return { initialOverrides: film.initialOverrides, firstProgress: film.firstProgress, lastProgress: film.lastProgress,
    durationSeconds: film.durationSeconds, waypoints: film.sequence ? cinematicTimeline(film.ride.points, film.sequence, film.durationSeconds) : [] };
}
